export default "/_next/static/chunks/fonts/Funnel Display Light-f2f65bad267cc33fbea5843298171976.ttf";